import { render, staticRenderFns } from "./editable.vue?vue&type=template&id=edee3f1c"
import script from "./editable.vue?vue&type=script&lang=js"
export * from "./editable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports